import type { ActionType } from './action'
import type { Language } from '../i18n'

export interface ActivityRecord {
  id: string
  areaId: string
  areaName: string
  actionId: string
  actionName: string
  objectiveIds?: string[]
  type: ActionType
  amount: number
  xp: number
  coins: number
  startedAt: number | null
  completedAt: number
}

export type MilestoneKind = 'objective' | 'uniqueAction'

export interface Milestone {
  id: string
  areaId: string
  areaName: string
  title: string
  kind: MilestoneKind
  xp: number
  coins: number
  achievedAt: number
}

export const historyAmountLabel = (record: ActivityRecord, language: Language = 'es') => {
  if (record.type === 'simple') return language === 'es' ? 'Completada' : 'Completed'
  if (record.type === 'counter') return `${record.amount} reps`
  const hours = Math.floor(record.amount / 60)
  const minutes = record.amount % 60
  if (hours === 0) return `${minutes} min`
  if (minutes === 0) return `${hours} h`
  return `${hours} h ${minutes} min`
}
